









import { defineComponent, PropType } from "@vue/composition-api";
import { CreatorServiceTransactionDetails } from "@scrile/api-provider/dist/api/CreatorServicesProvider";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import TransactionView from "../TransactionView.vue";

export default defineComponent({
  name: "TransactionCreatorServicePurchase",
  components: { TransactionView },
  props: {
    transaction: { type: Object as PropType<Transaction<CreatorServiceTransactionDetails>>, required: true },
  },
});
